(function($) {
    'use strict';
    var FormOrder = function(el, options) {
        this.settings = options;
        this.$el = $(el);
        this.$products = this.$el.find('.order-product');
        this.$pointsUsed = this.$el.find('.points-used');
        this.pointsAvailable = this.getNumber(this.$el.find('.points-available').text());
        this.sumtable = null;
        this.defaults = $.extend(
            {
                decimals: 2,
                sumTableTarget: this.$el.data('target-sum-table')
            },
            this.settings
        );
        this.init();
    };
    FormOrder.prototype = {
        init: function() {
            this.settings = $.extend({}, this.defaults, this.settings);
            this.$sumtable = $('[data-sum-table="' + this.settings.sumTableTarget + '"]');
            this.bindEvents();
            $('.js-exceeded-points').css('display', 'none').tooltip();
        },
        bindEvents: function() {
            var that = this;
            that.$products.on('change', '.product-unit', function() {
                var $selected = $('option:selected', this),
                    $product = $selected.closest('.order-product');
                that.setProductUnit($product, $selected);
                that.calculateTotal();
            });
            that.$products.on('change keyup', '.product-quantity', function() {
                that.calculateTotal();
            });
            that.$products.on('change', '.use-points', function() {
                that.calculateTotal();
            });
            $(window).on('form-row-deleted', function() {
                that.calculateTotal();
            });
        },
        setProductUnit: function($product, $unit) {
            var that = this;
            $product.find('.product-pieces').text($unit.data('pieces'));
            $product.find('.product-price').text(that.setNumber($unit.data('price')));
            $product.find('.points-cost').data('points', $unit.data('points'));
            $product.find('.product-quantity').prop('disabled', false);
        },
        calculateTotal: function() {
            var that = this,
                units = {
                    points: 0,
                    total: 0
                };

            // Calculate and update each product
            that.$products.not('.delete').each(function() {
                var $product = $(this),
                    $value = $product.find('.product-value'),
                    $points = $product.find('.points-cost'),
                    $usePoints = $product.find('.use-points'),
                    unit,
                    totalValue,
                    points;

                // Calculate values
                var price = that.getNumber($product.find('.product-price').text());
                var quantity = that.getNumber($product.find('.product-quantity').val());
                // Calculate total product value
                totalValue = price * quantity;
                $value.text(that.setNumber(totalValue));
                // Calculate points
                points = that.getNumber($points.data('points')); // * quantity;
                $points = $points.text(points);
                // Add to total
                if ($usePoints.is(':checked')) {
                    units.points += points * quantity;
                } else {
                    units.total += totalValue;
                }
                // Add to total units array
                unit = $product.find('.product-unit').val();
                if (unit) {
                    if (units[unit]) {
                        units[unit] += quantity;
                    } else {
                        units[unit] = quantity;
                    }
                }
                if (that.pointsAvailable < units.points) {
                    var $row;
                    $('.js-exceeded-points')
                        .filter(function() {
                            $row = $(this).closest('tr');
                            if ($row.find('.use-points').is(':checked')) {
                                return true;
                            }

                            return false;
                        })
                        .css('display', 'inline-block');
                } else {
                    $('.js-exceeded-points').css('display', 'none');
                }
            });
            // Update sumtable
            that.$sumtable.find('.sum').each(function() {
                var $sum = $(this),
                    unit = $sum.data('sum'),
                    decimals = $sum.data('decimals'),
                    value = 0;
                if (units[unit]) {
                    value = units[unit];
                }
                $sum.text(that.setNumber(value, decimals));
            });
            // Update points used
            that.$pointsUsed.text(units.points);
        },
        getNumber: function(value) {
            var number = Number(value);
            number = isNaN(number) ? 0 : number;
            number = Math.max(0, number);

            return number;
        },
        setNumber: function(number, decimals) {
            if (!decimals) {
                decimals = this.settings.decimals;
            }

            return number.toFixed(decimals);
        }
    };
    $.fn.formOrder = function(options) {
        var args = Array.prototype.slice.call(arguments, 1),
            $this,
            data;

        return this.each(function() {
            $this = $(this);
            data = $this.data('formOrder');
            if (!data) {
                $this.data('formOrder', (data = new FormOrder(this, options)));
            }
            if (typeof options === 'string') {
                data[options](args);
            }
        });
    };
    $.fn.formOrder.Constructor = FormOrder;
})(jQuery);
